<template>
    <base-view class="list-view">
        <slot name="before"></slot>
        <slot></slot>
        <slot name="header">
            <div class="list-header">
                <slot name="summary">
                    <div class="list-summary"><slot name="summaryContent"></slot></div>
                </slot>
                <slot name="filter">
                    <veui-form :data="store.filter" ui="inline" class="list-filter" @submit="submitSearch">
                        <slot name="filterContent"></slot>
                    </veui-form>
                </slot>
                <slot name="batch">
                    <div class="list-batch">
                        <slot name="batchContent"></slot>
                    </div>
                </slot>
            </div>
        </slot>
        <slot name="table">
            <veui-table :ui="store.tableUI"
                :data="store.tableData"
                :column-filter="store.tableColumns"
                :keys="store.tableKeys"
                :selectable="store.tableSelectable"
                :order-by="store.filter.orderBy"
                :order="store.filter.order"
                :scroll="store.tableScroll"
                :expandable="store.tableExpandable"
                :expanded="store.tableExpanded"
                @select="tableSelect"
                @sort="tableSort"
                :selected.sync="store.tableSelected">
                <slot name="tableColumns"></slot>
                <template slot="sub-row" slot-scope="$scope">
                    <slot name="sub-row" v-bind="$scope"></slot>
                </template>
                <template slot="no-data">
                    <template v-if="store.initLoading">
                        <slot name="tableDataLoading">数据加载中</slot>
                    </template>
                    <template v-else>
                        <slot name="tableNoData">没有数据</slot>
                    </template>
                </template>
            </veui-table>
        </slot>
        <template v-if="store.needPagination">
            <slot name="pager">
                <div class="list-pager" v-show="!store.initLoading">
                    <veui-pagination :page="store.filter.pageNo"
                        :page-size="store.filter.pageSize"
                        :page-sizes="store.pageSizes"
                        :total="store.totalCount"
                        ui="full"
                        native
                        @pagesizechange="handlePageSizeChange"
                        @redirect="handleRedirect">
                    </veui-pagination>
                </div>
            </slot>
        </template>
        <slot name="after"></slot>
    </base-view>
</template>

<script>
import BaseView from './BaseView';
import {Pagination, Form, Table} from 'veui';
import createView from './createView';
import ListModel from './ListModel';

export default createView(BaseView, ListModel, {
    name: 'list-view',
    components: {
        'veui-form': Form,
        'veui-table': Table,
        'veui-pagination': Pagination
    },
    props: {
        initialData: null
    },
    created() {
        this.global.redirect({
            url: this.store.getQueryUrl(),
            type: 'replace'
        });
        this.store.initListData(this.initialData);
        this.store.fillFilterFromQuery();

        this.$watch('$route.query', this.handleQueryChange);

        const unwatch = this.$watch(
            () => !this.global.requestCounter,
            () => {
                this.store.initLoading = false;
                unwatch();
            }
        );
    },
    methods: {
        // 必须延时比较，因为有可能同时修改 order 和 orderBy ，如果不延时比较，就会调用两次 requestList。
        handleQueryChange() {
            if (!this.queryCheckTask) {
                this.$nextTick(() => {
                    this.queryCheckTask();
                    this.queryCheckTask = null;
                });
            }

            this.queryCheckTask = () => {
                this.store.requestList();
                this.store.fillFilterFromQuery();
            };
        },
        handlePageSizeChange(pageSize) {
            this.store.pageSizeChange(pageSize);
        },
        handleRedirect(pageNo) {
            // 去掉 to+watch 方式，改成事件绑定，是为了兼容IE10和edge无法响应切换页码问题
            this.store.pageNoChange(pageNo);
        },
        tableSelect(...args) {
            this.store.tableSelect(...args);
        },
        tableSort(...args) {
            this.store.tableSort(...args);
        },
        submitSearch() {
            this.store.submitSearch();
        }
    }
});
</script>

<style lang="less">
@import "~less-plugin-est/src/util.less";

.base-view.list-view {
    .list-summary {
        padding: 10px 0;

        &:empty {
            padding: 0;
        }
    }

    .list-header {
        margin: 30px 0 40px;

        &:first-child {
            margin-top: 0;
        }

        .list-filter {
            .filter-right {
                margin-left: 0;
            }
        }
    }

    .list-filter {
        .veui-fieldset:last-child,
        .veui-field:last-child {
            margin-bottom: 0;
        }

        .filter-left {
            float: left;
        }

        .filter-right {
            float: right;
        }
    }

    .list-pager {
        .clearfix();
        margin-top: 10px;

        .veui-pagination {
            float: right;
        }

        .veui-pagination-switch {
            padding-right: 0;
        }

        .veui-pagination-page .veui-link {
            cursor: pointer;
        }
        .veui-pagination-page.veui-active .veui-link {
            cursor: default;
        }
    }
}
</style>
